import { Injectable } from '@angular/core';

 import * as XLSX from 'xlsx';

import {saveAs}   from 'file-saver';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = 'xlsx';
@Injectable({
  providedIn: 'root'
})
export class ExcelSerService {

  constructor() { }

  public exportASExcelFile(
    reportHeading: string,
    reportSubHeading: string,
    headersArray: any[],
    json: any[],
    footerData: any,
    excelFileName: string,
    sheetName: string,
    celdasMoneda: any[] = []
  ) {
    const worksheetData: any[][] = [];

    // Primera fila: Título principal
    worksheetData.push([reportHeading]);
    worksheetData.push([]);

    // Subtítulo
    if (reportSubHeading !== '') {
      worksheetData.push([reportSubHeading]);
      worksheetData.push([]);
    }

    // Encabezados
    worksheetData.push(headersArray.map(col => col.header));

    // Datos
    json.forEach((element: any) => {
   
      const eachRow = headersArray.map(col => element[col.key] ?? '');
      worksheetData.push(eachRow);
    });

    // Footer (si existe)
    if (footerData != null) {
      worksheetData.push([]);
      footerData.forEach((element: any) => {
        worksheetData.push(element);
      });
    }

    // Crear hoja y libro
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook: XLSX.WorkBook = {
      Sheets: { [sheetName]: worksheet },
      SheetNames: [sheetName]
    };

    // Formatear columnas de moneda si es necesario
    if (celdasMoneda.length > 0) {
      celdasMoneda.forEach((colName) => {
        const colIndex = headersArray.indexOf(colName);
        if (colIndex !== -1) {
          const colLetter = this.numToAlpha(colIndex);
          for (let row = 5; row <= worksheetData.length; row++) { // Datos comienzan después de headers
            const cellRef = colLetter + row;
            if (worksheet[cellRef]) {
              worksheet[cellRef].z = '$#,##0.00';
            }
          }
        }
      });
    }

    // Escribir archivo
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Guardar archivo
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    saveAs(data, `${excelFileName}.${EXCEL_EXTENSION}`);
  }

  private numToAlpha(num: number) {
    let alpha = '';
    for (; num >= 0; num = Math.floor(num / 26) - 1) {
      alpha = String.fromCharCode((num % 26) + 65) + alpha;
    }
    return alpha;
  }

}
